import { Diamond, Flag, Play, User } from "lucide-react";

const TYPE_CLS = {
  start: "bg-emerald-50 border-emerald-300 text-emerald-900",
  step: "bg-card border-border",
  decision: "bg-amber-50 border-amber-300 text-amber-900",
  end: "bg-slate-100 border-slate-300 text-slate-800",
  yes: "bg-emerald-50/80 border-emerald-200 text-emerald-900",
  no: "bg-rose-50/80 border-rose-200 text-rose-900",
};

export default function ProcessSwimlanes({ steps }) {
  const seq = [];
  let n = 0;
  (steps || []).forEach((s) => {
    n += 1;
    seq.push({ ...s, seq: String(n), kind: s.type || "step" });
    if (s.type === "decision") {
      (s.yes_steps || []).forEach((b, j) => seq.push({ ...b, seq: `${n}·Y${j + 1}`, kind: "yes" }));
      (s.no_steps || []).forEach((b, j) => seq.push({ ...b, seq: `${n}·N${j + 1}`, kind: "no" }));
    }
  });
  const lanes = [];
  seq.forEach((s) => {
    const owner = (s.owner || "").trim() || "Unassigned";
    if (!lanes.includes(owner)) lanes.push(owner);
  });

  if (!seq.length) return <p className="text-sm text-muted-foreground border border-dashed border-border rounded-lg px-6 py-8 text-center">No steps yet — add steps to see the swimlanes.</p>;

  return (
    <div className="space-y-2.5 py-2" data-testid="process-swimlanes">
      <p className="text-[11px] text-muted-foreground">Steps grouped by owner, numbered in flow order (Y/N = decision branch steps).</p>
      {lanes.map((owner) => {
        const inLane = seq.filter((s) => ((s.owner || "").trim() || "Unassigned") === owner);
        return (
          <div key={owner} className="flex items-stretch border border-border rounded-xl overflow-hidden bg-card/40" data-testid={`swimlane-${owner}`}>
            <div className="w-36 shrink-0 bg-secondary/70 border-r border-border px-3 py-3 flex items-start">
              <p className="text-xs font-bold flex items-center gap-1.5 leading-tight"><User className="h-3.5 w-3.5 text-primary shrink-0" /> {owner}
                <span className="text-[10px] font-semibold text-muted-foreground">({inLane.length})</span></p>
            </div>
            <div className="flex-1 min-w-0 p-3 flex flex-wrap gap-2 items-start content-start">
              {inLane.map((s) => (
                <div key={`${s.id}-${s.seq}`} className={`inline-flex items-center gap-1.5 border rounded-lg px-2.5 py-1.5 text-xs ${TYPE_CLS[s.kind] || TYPE_CLS.step}`} data-testid={`swimlane-step-${s.id}`}>
                  <span className="font-mono text-[10px] font-bold opacity-60 shrink-0">{s.seq}</span>
                  {s.kind === "decision" && <Diamond className="h-3 w-3 shrink-0" />}
                  {(s.kind === "start" || s.kind === "end") && <Play className="h-3 w-3 shrink-0" />}
                  {s.is_milestone && <Flag className="h-3 w-3 shrink-0" />}
                  <span className="font-semibold">{s.title}</span>
                  {(s.kind === "yes" || s.kind === "no") && (
                    <span className={`text-[9px] font-bold uppercase px-1 rounded ${s.kind === "yes" ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"}`}>{s.kind}</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
